import { createContext, useContext, useState } from "react";

// Shares the currently-open ticket's clientType (set by the /Ticket dispatcher)
// so the sidebar can highlight the right section — the ticket detail uses the
// shared /Ticket/:id route, so the URL alone can't tell JBM from RCS.
const TicketContext = createContext({
  ticketClientType: null,
  setTicketClientType: () => {},
});

export const TicketProvider = ({ children }) => {
  const [ticketClientType, setTicketClientType] = useState(null);
  return (
    <TicketContext.Provider value={{ ticketClientType, setTicketClientType }}>
      {children}
    </TicketContext.Provider>
  );
};

export const useTicketContext = () => useContext(TicketContext);
